module.exports = __webpack_public_path__ + "static/media/water1.a82b4cfb.jpg";